<script setup lang="ts">
import type { Props } from '@/shared/ui/AppLogo/model/types/appLogo';

import Logo from '@/shared/ui/Icons/AppLogo.vue';
import LogoWhite from '@/shared/ui/Icons/AppLogoWhite.vue';

defineOptions({
  name: 'AppLogo',
});

withDefaults(defineProps<Props>(), {
  isWhite: false,
});
</script>

<template>
  <NuxtLink class="logo" data-testid="logo" to="/" aria-label="На главную">
    <span
      style="width: 0; opacity: 0; height: 0; pointer-events: none; display: inline-block"
      >logo</span
    >
    <LogoWhite v-if="isWhite" />
    <Logo v-else />
  </NuxtLink>
</template>

<style lang="less">
.logo {
  display: inline-flex;

  svg {
    width: 100%;
    height: 100%;
  }
}
</style>
